import React,{useContext,useState,useEffect} from 'react'
import FlexView from 'react-flexview/lib'
import { Grid, TextField, useMediaQuery,Divider } from '@material-ui/core'
import { PasswordInput } from '../Core/PasswordInput'
import { useForm } from 'react-hook-form'
import NewFillButton from '../Core/NewFillButton'
import { EventEmitterService, EventKey } from '../../services/EventEmitterService'
import AccountApi from '../../api/account.api'
import { awaitWithLoading } from '../../services/utils'
import { EMAIL_REGEX } from '../../Constants'
import { SessionService } from '../../services/SessionService'
import { UserProfileContextStore } from "../../context/UserProfileContext";
import { SessionContextStore } from '../../context/SessionContext';
import { ApproveRefferalRequest } from './ApproveRefferalRequest';
import './ManageProfile.scss'

var classNames = require('classnames')

export const RefferalRequests = () => {
    const { register, triggerValidation, errors, getValues } = useForm({mode: 'onChange'})
    const isMobile = !useMediaQuery(theme => theme.breakpoints.up('md'));
    const sessionContext = React.useContext(SessionContextStore)
    const [openRefferedRequests,setOpenRefferedRequests] = useState()

    const closeReffedRequest = (declination)=> {      
        var temp = openRefferedRequests.filter(x=>x.property != declination.reason)
        if(temp.length == 0){
            window.location.reload()
        }
        setOpenRefferedRequests(temp)
    }

    useEffect(()=>{
        sessionContext.user.declinations.forEach(e=>e.declined = e.type === 'Decline')
        setOpenRefferedRequests(sessionContext.user.declinations)
    },[sessionContext.user.declinations])

    return (
        <FlexView column>
        <Grid spacing={3}>
        {sessionContext.user.declinations.length == 0 ? 
        <h4>No open refferal requests</h4>
        :sessionContext.user.declinations.map((declination) => 
                <>
                <ApproveRefferalRequest closeReffedRequest={closeReffedRequest} allowed={declination.override_type === "Allow"} declined={declination.override_type === "Decline" || declination.declined} declinationDate={declination.declination_date} reason={declination.property} comment={declination.declination_comment} payload= {declination.payload}/>
                <Divider/>
                </>)}                
        </Grid>
        </FlexView>
    )
}